import React, {Component, useEffect, useState} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import clsx from "clsx";

/**
 * This will render either its children or a link that, when clicked, reveals the
 * component's hidden children. Upon doing so the link disappears.
 *
 * See also RevealContentButton, for a button that reveals content elsewhere on the page.
 *
 * @param defaultVisible
 * @param tabIndex
 * @param caption
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function HiddenContentWrapper({
  defaultVisible, tabIndex, caption,
  captionClassName,
  renderPrompt, // a rendered Component
  ...props
}) {
  const {id = null, className = "", children} = props;

  const [visible, setVisible] = useState(defaultVisible);

  useEffect(() => {
    setVisible(defaultVisible)
  }, [defaultVisible]);

  const handleClick = () => setVisible(true);

  renderPrompt ||= () => caption || "Click to Activate"

  let wrapperClasses = clsx([
    (visible ? 'max-h-screen' : 'max-h-0'),
    'overflow-hidden transition transition-all duration-500'
  ]);

  captionClassName = clsx(
    captionClassName || 'block',
    (visible ? 'max-h-0' : 'max-h-screen' ),
    'overflow-hidden',
    //'transition transition-all duration-500'
  )

  return (
    <div id={id} className={clsx(className)}>
      <a onClick={handleClick}
        className={captionClassName}
        tabIndex={tabIndex}>{renderPrompt()}</a>

      <div className={wrapperClasses}>
        {children}
      </div>
    </div>
  );

}

function RevealContentLink({setVisible, tabIndex, caption}) {
  const handleClick = (e) => setVisible(true);

  return (
    <a onClick={handleClick} tabIndex={tabIndex}>{caption}</a>
  );
}

HiddenContentWrapper.propTypes = {
  tabIndex: PropTypes.number
};
